// import React, { useState, useEffect } from "react";
// import {
//   useGetNotificationsQuery,
//   useMarkNotificationAsReadMutation,
//   useMarkAllNotificationsAsReadMutation
// } from "../../store/api/notificationApi";
// import { useNavigate } from "react-router-dom";

// import { formatLocalTime } from "../../utils/dateTime";
// import styles from "./NotificationsPage.module.css";
// import Header from "../../components/Header";

// export default function NotificationsPage(){

//   const [cursor,setCursor] = useState(null);
//   const [notifications,setNotifications] = useState([]);
//   const navigate = useNavigate();

// const [markAsRead] = useMarkNotificationAsReadMutation();
// const [markAllAsRead] = useMarkAllNotificationsAsReadMutation();

// const handleClick = (notification) => {

//   if(!notification.isRead){

//     setNotifications(prev =>
//       prev.map(n =>
//         n.id === notification.id
//           ? {...n, isRead:true}
//           : n
//       )
//     );

//     markAsRead(notification.id);

//   }

//   switch(notification.type){

//     case 'Follow':
//       navigate(`/profile/${notification.users?.[0]?.id}`);
//       break;

//     case 'Like':
//     case 'Comment':
//     case 'Share':
//       navigate(`/post/${notification.postId}`);
//       break;

//     case 'ChatRequest':
//       navigate('/chat?request=true');
//       break;

//     default:
//       navigate('/home');

//   }

// };

// const unreadCount =
//   notifications.filter(n => !n.isRead).length;

//   const {data,isLoading} =
//     useGetNotificationsQuery({
//       cursor,
//       pageSize:20
//     });

//   useEffect(()=>{

//     if(!data?.notifications) return;

//     setNotifications(prev=>{

//       const merged=[...prev];

//       data.notifications.forEach(n=>{

//         const index =
//           merged.findIndex(x=>x.id===n.id);

//         if(index!==-1)
//           merged[index]=n;
//         else
//           merged.push(n);

//       });

//       return merged;

//     });

//   },[data]);

//   if(isLoading)
//     return <div className={styles.page}>
//       Loading...
//     </div>;

//   return (

// <>
//   <Header/>
//   <div className={styles.wrapper}>

//     <div className={styles.container}>

//       <div className={styles.card}>

//        <div className={styles.cardHeader}>

//   <div className={styles.titleBlock}>

//     <h2 className={styles.title}>
//       Notifications
//     </h2>

//     {unreadCount > 0 && (
//       <div className={styles.unreadBadge}>
//         {unreadCount}
//       </div>
//     )}

//   </div>

//   {unreadCount > 0 && (

//     <button
//       className={styles.markAllBtn}
//       onClick={async ()=>{

//         setNotifications(prev =>
//           prev.map(n => ({
//             ...n,
//             isRead:true
//           }))
//         );

//         await markAllAsRead();

//       }}
//     >
//       Mark all as read
//     </button>

//   )}

// </div>


//         <div className={styles.notificationList}>

//           {notifications.map(n => (

//             <div
//               key={n.id}
//               onClick={()=>handleClick(n)}
//               className={`
//                 ${styles.notificationItem}
//                 ${!n.isRead ? styles.unread : ""}
//               `}
//             >

//               <div className={styles.avatarWrap}>

//                 {n.users?.[0]?.profilePhotoUrl ? (

//                   <img
//                     src={n.users[0].profilePhotoUrl}
//                     className={styles.avatar}
//                     alt=""
//                   />

//                 ) : (

//                   <div className={styles.avatarFallback}>
//                     {n.users?.[0]?.name?.charAt(0)}
//                   </div>

//                 )}

//               </div>

//               <div className={styles.textContent}>

//                 <p className={styles.message}>
//                   {getNotificationText(n)}
//                 </p>

//                 <span className={styles.time}>
//                   {formatLocalTime(n.createdAt)}
//                 </span>

//               </div>

//               {!n.isRead &&
//                 <div className={styles.unreadDot}></div>
//               }

//             </div>

//           ))}

//         </div>

//       </div>

//     </div>

//   </div>

// </>
// );

// }

// function getNotificationText(notification){

//   const user =
//     notification.users?.[0];

//   if(!user) return "Notification";

//   switch(notification.type){

//     case "Like":
//       return `${user.name} liked your post`;

//     case "Comment":
//       return `${user.name} commented on your post`;

//     case "Follow":
//       return `${user.name} followed you`;

//     case "ChatRequest":
//       return `${user.name} sent chat request`;

//     default:
//       return `${user.name} sent notification`;
//   }

// }


import React, { useState, useEffect } from "react";
import {
  useGetNotificationsQuery,
  useMarkNotificationAsReadMutation,
  useMarkAllNotificationsAsReadMutation
} from "../../store/api/notificationApi";
import { useNavigate } from "react-router-dom";
 
import { formatLocalTime } from "../../utils/dateTime";
import styles from "./NotificationsPage.module.css";
import Header from "../../components/Header";
 
const TYPE_META = {
  Like:                 { icon: "\u2764",   badge: styles.badgeLike },
  LikeShared:           { icon: "\u2764",   badge: styles.badgeLike },
  Comment:              { icon: "\uD83D\uDCAC", badge: styles.badgeComment },
  CommentShared:        { icon: "\uD83D\uDCAC", badge: styles.badgeComment },
  Reply:                { icon: "\u21A9",   badge: styles.badgeComment },
  Follow:               { icon: "+",        badge: styles.badgeFollow },
  Share:                { icon: "\u2197",   badge: styles.badgeShare },
  ChatRequest:          { icon: "\u2709",   badge: styles.badgeChat },
  ChatRequestAccepted:  { icon: "\u2713",   badge: styles.badgeChat },
  PostLocked:           { icon: "\uD83D\uDD12", badge: styles.badgeLocked },
  SharedPostRemoved:    { icon: "\uD83D\uDEAB", badge: styles.badgeRemoved },
};
 
function getTypeMeta(type) {
  return TYPE_META[type] || { icon: "\uD83D\uDD14", badge: styles.badgeDefault };
}
 
function getDayLabel(dateString) {
  if (!dateString) return "Earlier";
  const date = new Date(dateString);
  const now = new Date();
  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);
 
  if (date.toDateString() === now.toDateString()) return "Today";
  if (date.toDateString() === yesterday.toDateString()) return "Yesterday";
 
  const daysAgo = Math.floor((now - date) / (1000 * 60 * 60 * 24));
  if (daysAgo < 7) return "This week";
  return "Earlier";
}
 
export default function NotificationsPage() {
 
  const [cursor, setCursor] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const navigate = useNavigate();
 
  const [markAsRead] = useMarkNotificationAsReadMutation();
  const [markAllAsRead] = useMarkAllNotificationsAsReadMutation();
 
  // FIX: unified click handler — added Reply, LikeShared, CommentShared,
  // and now passes postType + commentId so the post page can deep-link
  // to the exact comment/reply.
  const handleClick = (notification) => {
 
    if (!notification.isRead) {
      setNotifications(prev =>
        prev.map(n => n.id === notification.id ? { ...n, isRead: true } : n)
      );
      markAsRead(notification.id);
    }
 
   // REPLACE the navigation switch in handleNotificationClick / handleClick with:
 
const postType = notification.postType || "Post";
const navigationId = notification.sharedPostId ?? notification.postId;
 
switch (notification.type) {
  case 'ChatRequest':
    navigate('/chat?request=true');
    break;
 
  case 'ChatRequestAccepted':
    navigate('/chat');
    break;
 
  case 'Like':
  case 'LikeShared':
    if (navigationId) {
      navigate(`/post/${navigationId}?type=${postType}`);
    }
    break;
 
  case 'Comment':
  case 'CommentShared':
    if (navigationId) {
      navigate(`/post/${navigationId}?type=${postType}`, {
        state: { commentId: notification.commentId },
      });
    }
    break;
 
  case 'Reply':
    if (navigationId) {
      navigate(`/post/${navigationId}?type=${postType}`, {
        state: { commentId: notification.commentId, isReply: true },
      });
    }
    break;
 
  case 'Share':
    if (notification.postId) {
      navigate(`/post/${notification.postId}?type=${postType}`);
    }
    break;
 
  case 'Follow':
    if (notification.users?.[0]?.id) {
      navigate(`/profile/${notification.users[0].id}`);
    }
    break;
 
  case 'PostLocked':
    if (notification.postId) navigate(`/post/${notification.postId}`);
    else navigate('/home');
    break;
 
  case 'SharedPostRemoved':
    navigate('/home');
    break;
 
  default:
    navigate('/home');
}
  };
 
  const unreadCount = notifications.filter(n => !n.isRead).length;
 
  const { data, isLoading, isFetching } = useGetNotificationsQuery({
    cursor,
    pageSize: 20
  });
 
  const hasMore = !!data?.nextCursor;
 
  useEffect(() => {
    if (!data?.notifications) return;
 
    setNotifications(prev => {
      const merged = [...prev];
      data.notifications.forEach(n => {
        const index = merged.findIndex(x => x.id === n.id);
        if (index !== -1) merged[index] = n;
        else merged.push(n);
      });
      return merged;
    });
  }, [data]);
 
  if (isLoading)
    return (
      <>
        <Header />
        <div className={styles.page}>Loading...</div>
      </>
    );
 
  let lastDayLabel = null;
 
  return (
    <>
      <Header />
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.card}>
 
            <div className={styles.cardHeader}>
              <div className={styles.titleBlock}>
                <h2 className={styles.title}>Notifications</h2>
                {unreadCount > 0 && (
                  <div className={styles.unreadBadge}>{unreadCount}</div>
                )}
              </div>
 
              {unreadCount > 0 && (
                <button
                  className={styles.markAllBtn}
                  onClick={async () => {
                    setNotifications(prev => prev.map(n => ({ ...n, isRead: true })));
                    await markAllAsRead();
                  }}
                >
                  Mark all as read
                </button>
              )}
 
              
            </div>
 
            {notifications.length === 0 ? (
              <div className={styles.emptyState}>
                <div className={styles.emptyIcon}>{"\uD83D\uDD14"}</div>
                <p className={styles.emptyTitle}>No notifications yet</p>
                <p className={styles.emptyText}>
                  When people interact with your posts and profile, you'll see it here.
                </p>
              </div>
            ) : (
              <div className={styles.notificationList}>
                {notifications.map((n) => {
                  const dayLabel = getDayLabel(n.createdAt);
                  const showDayLabel = dayLabel !== lastDayLabel;
                  lastDayLabel = dayLabel;
                  const meta = getTypeMeta(n.type);
 
                  return (
                    <React.Fragment key={n.id}>
                      {showDayLabel && <div className={styles.dayLabel}>{dayLabel}</div>}
 
                      <div
                        onClick={() => handleClick(n)}
                        className={`${styles.notificationItem} ${!n.isRead ? styles.unread : ""}`}
                      >
                        <div className={styles.avatarWrap}>
                          {n.users?.[0]?.profilePhotoUrl ? (
                            <img
                              src={n.users[0].profilePhotoUrl}
                              className={styles.avatar}
                              alt=""
                            />
                          ) : (
                            <div className={styles.avatarFallback}>
                              {n.users?.[0]?.name?.charAt(0)?.toUpperCase() || "?"}
                            </div>
                          )}
                          <div className={`${styles.typeBadge} ${meta.badge}`}>
                            {meta.icon}
                          </div>
                        </div>
 
                        <div className={styles.textContent}>
                          <p
                            className={styles.message}
                            dangerouslySetInnerHTML={{ __html: getNotificationText(n) }}
                          />
                          <span className={styles.time}>
                            {formatLocalTime(n.createdAt)}
                          </span>
                        </div>
 
                        {!n.isRead && <div className={styles.unreadDot} />}
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            )}
 
            {hasMore && (
              <div className={styles.loadMoreWrap}>
                <button
                  className={styles.loadMoreBtn}
                  onClick={() => setCursor(data.nextCursor)}
                  disabled={isFetching}
                >
                  {isFetching
                    ? <span className={styles.loadingDots}>Loading<span>.</span><span>.</span><span>.</span></span>
                    : "Load More Notifications"}
                </button>
              </div>
            )}
 
          </div>
        </div>
      </div>
    </>
  );
}
 
function getNotificationText(notification) {
  const user = notification.users?.[0];
 
  if (notification.type === "PostLocked") {
    return notification.commentText
      || "Your post was hidden because it was reported by multiple users.";
  }
 
  if (notification.type === "SharedPostRemoved") {
    return notification.commentText
      || "Your shared post was removed because it was reported by multiple users.";
  }
 
  if (!user) return "Notification";
 
  const name = `<strong>${user.name}</strong>`;
 
  switch (notification.type) {
    case "Like":
      return `${name} liked your post`;
    // FIX: was missing — fell through to default "sent notification"
    case "LikeShared":
      return `${name} liked a post you shared`;
    case "Comment":
      return `${name} commented on your post`;
    // FIX: was missing
    case "CommentShared":
      return `${name} commented on a post you shared`;
    // FIX: was missing — this is the main bug reported
    case "Reply":
      return `${name} replied to your comment`;
    case "Follow":
      return `${name} followed you`;
    case "Share":
      return `${name} shared your post`;
    case "ChatRequest":
      return `${name} sent chat request`;
    case "ChatRequestAccepted":
      return `${name} accepted your chat request`;
    default:
      return `${name} sent notification`;
  }
}